import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { cloneDeep } from 'lodash';

import Spinner from '../common/spinner';
import InHomeSchedulingButtons from './InHomeSchedulingButtons';
import AppointmentOverview from './AppointmentOverview';
import SchedulingQuestions from './SchedulingQuestions';
import CustomCheckbox from "../common/CustomCheckbox";
import StickyProgressBar from '../common/StickyProgressBar';


const InHomeWhich = ({ serviceLocation, history, getAvailableVaccines, getVaccinePending, eligibleVaccines, setSelectedVaccines }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Displayed`, new Date(), Tools.getURLPath());
    }, []);

    useEffect(() => {
        if (vaccineSelected === null || vaccineSelected.length === 0) {
            setVaccineSelected(eligibleVaccines);
        }
    }, [eligibleVaccines])

    const [vaccineSelected, setVaccineSelected] = useState(null);
    const [showWarning, setShowWarning] = useState(false);

    const isNextButtonDisabled = () => {
        return vaccineSelected && vaccineSelected.every((each) => each.vaccines.every((vaccine) => vaccine.isChecked === false || vaccine.isChecked === undefined))
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Previous.Clicked`, new Date(), Tools.getURLPath());
        if (!isNextButtonDisabled()) {
            setSelectedVaccines(vaccineSelected);
            history.push("/inhomeschedule/s5")
        } else {
            setShowWarning(true);
        }
    }

    const onClickPrev = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhich.Next.Clicked`, new Date(), Tools.getURLPath());
        setSelectedVaccines(vaccineSelected);
        history.push("/inhomeschedule/s3")
    }

    const handleCheck = (index, userIndex) => {
        let temp = [...vaccineSelected];
        temp[userIndex].vaccines[index].isChecked = !temp[userIndex].vaccines[index].isChecked;
        setVaccineSelected(temp);
    }

    return (
        <>
            {!serviceLocation ? <Redirect to='/inhomeschedule/s3' /> :
                <>
                    <StickyProgressBar className="inhome" widthInPercent={1 / 2 * 100} />
                    <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="row flex">
                                    <div className="in-home-left-panel scheduling-wrapper">
                                        <div className="detail-wrapper which-detail-wrapper">
                                            <h1 className="page-heading">Which vaccinations would you like to receive?</h1>
                                            {getVaccinePending && <Spinner />}
                                            <div className="vaccine-selection-div">
                                                {vaccineSelected && vaccineSelected.map((user, userIndex) => {
                                                    return (
                                                        <div key={userIndex}>
                                                            <h2 className="recipient-name"> {user.patientName}</h2>
                                                            {user.vaccines?.length ?
                                                                <div className="recipients-selection-wrapper">
                                                                    {
                                                                        user.vaccines.map((data, index) => {
                                                                            const displayName = data.displayName.replace(/tdap/i, "Tdap (Tetanus, Diphtheria, Pertussis)");
                                                                            return <CustomCheckbox
                                                                                label={displayName.toUpperCase()}
                                                                                key={`eligibleVaccine-${index}`}
                                                                                isChecked={data.isChecked || false}
                                                                                handleCheck={() => handleCheck(index, userIndex)}
                                                                            />
                                                                        })
                                                                    }
                                                                </div>
                                                                :
                                                                <div className="recipient-noVaccine-msg"> We’re sorry. There are currently no vaccines available for this user at this time.</div>
                                                            }
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <InHomeSchedulingButtons leftOnClick={onClickPrev} rightOnClick={onClickNext} showWarning={showWarning} />
                                        </div>
                                        <SchedulingQuestions />
                                    </div>
                                    <div className="in-home-right-panel">
                                        <AppointmentOverview vaccinesPhase={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </>
            }</>
    );
}
const mapStateToProps = state => {
    const selectedUsers = state.inHome.selectedUsers;
    const vaccinesDetails = state.inHome.getVaccineResult;
    const vaccinesData = vaccinesDetails?.data || [];
    const usersAndVaccines = [];
    const selectedVaccines = cloneDeep(state.inHome.selectedVaccines);

    if (vaccinesData.length > 0) {
        selectedUsers.map((user) => {
            let patientName = user.patientName;
            let mrn = user.mrn;
            let dob = user.dob

            const extractUser = vaccinesData.find((vax) => { return vax.mrn === mrn });

            usersAndVaccines.push({ patientName, mrn, dob, vaccines: extractUser.vaccines });
        })
    }

    return {
        getVaccinePending: state.inHome.getVaccinePending,
        serviceLocation: state.inHome.serviceLocationContactInfo,
        eligibleVaccines: selectedVaccines ? selectedVaccines : usersAndVaccines,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedVaccines: (data) => {
            dispatch({ type: types.SET_INHOME_VACCINES, data })
        },
        getAvailableVaccines: () => {
            dispatch({ type: types.GET_INHOME_VACCINES })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhich);